import { useEffect, useCallback } from 'react';
import { useAtom } from 'jotai';
import { BlindKaizoRace } from '../../../../types/raceTypes';
import { blindKaizoRacesAtom, updateBlindKaizoRacesAtom } from '../../../../state/raceAtoms';

export function useRaceData(raceType: string) {
	const [blindKaizoRaces] = useAtom(blindKaizoRacesAtom);
	const [, updateBlindKaizoRaces] = useAtom(updateBlindKaizoRacesAtom);

	const fetchBlindKaizoRaces = useCallback(() => {
		fetch('/api/races', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				raceType: 'blindKaizo'
			})
		})
			.then(res => res.json())
			.then((res: BlindKaizoRace[]) => {
				updateBlindKaizoRaces(Array.isArray(res) ? res : []);
			})
			.catch(console.error);
	}, [updateBlindKaizoRaces]);

	useEffect(() => {
		if(raceType === 'mysteryMonday'){
			return;
		}
		if(raceType === 'blindKaizo' && blindKaizoRaces.length === 0){
			fetchBlindKaizoRaces();
		}
	}, [raceType, blindKaizoRaces.length, fetchBlindKaizoRaces]);

	return {
		blindKaizoRaces,
	};
}

